import SearchFormSimple from './SearchFormSimple'
export default SearchFormSimple
